import AF from "./flags/af.png";
import AX from "./flags/ax.png";
import AL from "./flags/al.png";
import DZ from "./flags/dz.png";
import AS from "./flags/as.png";
import AD from "./flags/ad.png";
import AO from "./flags/ao.png";
import AI from "./flags/ai.png";
import AQ from "./flags/aq.png";
import AG from "./flags/ag.png";
import AR from "./flags/ar.png";
import AM from "./flags/am.png";
import AW from "./flags/aw.png";
import AU from "./flags/au.png";
import AT from "./flags/at.png";
import AZ from "./flags/az.png";
import BS from "./flags/bs.png";
import BH from "./flags/bh.png";
import BD from "./flags/bd.png";
import BB from "./flags/bb.png";
import BY from "./flags/by.png";
import BE from "./flags/be.png";
import BZ from "./flags/bz.png";
import BJ from "./flags/bj.png";
import BM from "./flags/bm.png";
import BT from "./flags/bt.png";
import BO from "./flags/bo.png";
import BA from "./flags/ba.png";
import BW from "./flags/bw.png";
import BR from "./flags/br.png";
import IO from "./flags/io.png";
import BN from "./flags/bn.png";
import BG from "./flags/bg.png";
import CK from "./flags/ck.png";
import BF from "./flags/bf.png";
import BI from "./flags/bi.png";
import KH from "./flags/kh.png";
import CM from "./flags/cm.png";
import CA from "./flags/ca.png";
import CV from "./flags/cv.png";
import KY from "./flags/ky.png";
import CF from "./flags/cf.png";
import TD from "./flags/td.png";
import CL from "./flags/cl.png";
import CN from "./flags/cn.png";
import CX from "./flags/cx.png";
import CC from "./flags/cc.png";
import CO from "./flags/co.png";
import KM from "./flags/km.png";
import CG from "./flags/cg.png";
import CD from "./flags/cd.png";
import CR from "./flags/cr.png";
import CI from "./flags/ci.png";
import HR from "./flags/hr.png";
import CU from "./flags/cu.png";
import CY from "./flags/cy.png";
import CZ from "./flags/cz.png";
import DK from "./flags/dk.png";
import DJ from "./flags/dj.png";
import DM from "./flags/dm.png";
import DO from "./flags/do.png";
import EC from "./flags/ec.png";
import EG from "./flags/eg.png";
import SV from "./flags/sv.png";
import GQ from "./flags/gq.png";
import ER from "./flags/er.png";
import EE from "./flags/ee.png";
import ET from "./flags/et.png";
import FK from "./flags/fk.png";
import FO from "./flags/fo.png";
import FJ from "./flags/fj.png";
import FI from "./flags/fi.png";
import FR from "./flags/fr.png";
import GF from "./flags/gf.png";
import PF from "./flags/pf.png";
import GA from "./flags/ga.png";
import GM from "./flags/gm.png";
import GE from "./flags/ge.png";
import DE from "./flags/de.png";
import GH from "./flags/gh.png";
import GI from "./flags/gi.png";
import GR from "./flags/gr.png";
import GL from "./flags/gl.png";
import GD from "./flags/gd.png";
import GP from "./flags/gp.png";
import GU from "./flags/gu.png";
import GT from "./flags/gt.png";
import GG from "./flags/gg.png";
import GN from "./flags/gn.png";
import GW from "./flags/gw.png";
import GY from "./flags/gy.png";
import HT from "./flags/ht.png";
import VA from "./flags/va.png";
import HN from "./flags/hn.png";
import HK from "./flags/hk.png";
import HU from "./flags/hu.png";
import IS from "./flags/is.png";
import IN from "./flags/in.png";
import ID from "./flags/id.png";
import IR from "./flags/ir.png";
import IQ from "./flags/iq.png";
import IE from "./flags/ie.png";
import IM from "./flags/im.png";
import IL from "./flags/il.png";
import IT from "./flags/it.png";
import JM from "./flags/jm.png";
import JP from "./flags/jp.png";
import JE from "./flags/je.png";
import JO from "./flags/jo.png";
import KZ from "./flags/kz.png";
import KE from "./flags/ke.png";
import KI from "./flags/ki.png";
import KP from "./flags/kp.png";
import KR from "./flags/kr.png";
import KW from "./flags/kw.png";
import KG from "./flags/kg.png";
import LA from "./flags/la.png";
import LV from "./flags/lv.png";
import LB from "./flags/lb.png";
import LS from "./flags/ls.png";
import LR from "./flags/lr.png";
import LY from "./flags/ly.png";
import LI from "./flags/li.png";
import LT from "./flags/lt.png";
import LU from "./flags/lu.png";
import MO from "./flags/mo.png";
import MK from "./flags/mk.png";
import MG from "./flags/mg.png";
import MW from "./flags/mw.png";
import MY from "./flags/my.png";
import MV from "./flags/mv.png";
import ML from "./flags/ml.png";
import MT from "./flags/mt.png";
import MH from "./flags/mh.png";
import MQ from "./flags/mq.png";
import MR from "./flags/mr.png";
import MU from "./flags/mu.png";
import YT from "./flags/yt.png";
import MX from "./flags/mx.png";
import FM from "./flags/fm.png";
import MD from "./flags/md.png";
import MC from "./flags/mc.png";
import MN from "./flags/mn.png";
import ME from "./flags/me.png";
import MS from "./flags/ms.png";
import MA from "./flags/ma.png";
import MZ from "./flags/mz.png";
import MM from "./flags/mm.png";
// import AN from "./flags/an.png";
import NA from "./flags/na.png";
import NR from "./flags/nr.png";
import NP from "./flags/np.png";
import NL from "./flags/nl.png";
import NC from "./flags/nc.png";
import NZ from "./flags/nz.png";
import NI from "./flags/ni.png";
import NE from "./flags/ne.png";
import NG from "./flags/ng.png";
import NU from "./flags/nu.png";
import NF from "./flags/nf.png";
import MP from "./flags/mp.png";
import NO from "./flags/no.png";
import OM from "./flags/om.png";
import PK from "./flags/pk.png";
import PW from "./flags/pw.png";
import PS from "./flags/ps.png";
import PA from "./flags/pa.png";
import PG from "./flags/pg.png";
import PY from "./flags/py.png";
import PE from "./flags/pe.png";
import PH from "./flags/ph.png";
import PN from "./flags/pn.png";
import PL from "./flags/pl.png";
import PT from "./flags/pt.png";
import PR from "./flags/pr.png";
import QA from "./flags/qa.png";
// import RE from "./flags/re.png";
import RO from "./flags/ro.png";
import RU from "./flags/ru.png";
import RW from "./flags/rw.png";
import RE from "./flags/re.png";
import BL from "./flags/bl.png";
import SH from "./flags/sh.png";
import KN from "./flags/kn.png";
import LC from "./flags/lc.png";
import MF from "./flags/mf.png";
import PM from "./flags/pm.png";
import VC from "./flags/vc.png";
import WS from "./flags/ws.png";
import SM from "./flags/sm.png";
import ST from "./flags/st.png";
import SA from "./flags/sa.png";
import SN from "./flags/sn.png";
import RS from "./flags/rs.png";
import SC from "./flags/sc.png";
import SL from "./flags/sl.png";
import SG from "./flags/sg.png";
// import SX from "./flags/sx.png";
import SK from "./flags/sk.png";
import SI from "./flags/si.png";
import SB from "./flags/sb.png";
import SO from "./flags/so.png";
import ZA from "./flags/za.png";
import GS from "./flags/gs.png";
import SS from "./flags/ss.png";
import ES from "./flags/es.png";
import LK from "./flags/lk.png";
import SD from "./flags/sd.png";
import SR from "./flags/sr.png";
import SJ from "./flags/sj.png";
import SZ from "./flags/sz.png";
import SE from "./flags/se.png";
import CH from "./flags/ch.png";
import SY from "./flags/sy.png";
import TW from "./flags/tw.png";
import TJ from "./flags/tj.png";
import TZ from "./flags/tz.png";
import TH from "./flags/thai.svg";
import TL from "./flags/tl.png";
import TG from "./flags/tg.png";
import TK from "./flags/tk.png";
import TO from "./flags/to.png";
import TT from "./flags/tt.png";
import TN from "./flags/tn.png";
import TR from "./flags/tr.png";
import TM from "./flags/tm.png";
import TC from "./flags/tc.png";
import TV from "./flags/tv.png";
import UG from "./flags/ug.png";
import UA from "./flags/ua.png";
import AE from "./flags/ae.png";
import GB from "./flags/gb.png";
import US from "./flags/us.png";
// import UM from "./flags/um.png";
import UY from "./flags/uy.png";
import UZ from "./flags/uz.png";
import VU from "./flags/vu.png";
import VE from "./flags/ve.png";
import VN from "./flags/vn.png";
import VG from "./flags/vg.png";
import VI from "./flags/vi.png";
import WF from "./flags/wf.png";
// import EH from "./flags/eh.png";
import YE from "./flags/ye.png";
import ZM from "./flags/zm.png";
import ZW from "./flags/zw.png";

const FieldPhoneCountry = [
  {
    label: "Afghanistan",
    value: "93",
    code: "AF",
    image: AF,
  },
  {
    label: "Aland Islands",
    value: "358",
    code: "AX",
    image: AX,
  },
  {
    label: "Albania",
    value: "355",
    code: "AL",
    image: AL,
  },
  {
    label: "Algeria",
    value: "213",
    code: "DZ",
    image: DZ,
  },
  {
    label: "AmericanSamoa",
    value: "1684",
    code: "AS",
    image: AS,
  },
  {
    label: "Andorra",
    value: "376",
    code: "AD",
    image: AD,
  },
  {
    label: "Angola",
    value: "244",
    code: "AO",
    image: AO,
  },
  {
    label: "Anguilla",
    value: "1264",
    code: "AI",
    image: AI,
  },
  {
    label: "Antarctica",
    value: "672",
    code: "AQ",
    image: AQ,
  },
  {
    label: "Antigua and Barbuda",
    value: "1268",
    code: "AG",
    image: AG,
  },
  {
    label: "Argentina",
    value: "54",
    code: "AR",
    image: AR,
  },
  {
    label: "Armenia",
    value: "374",
    code: "AM",
    image: AM,
  },
  {
    label: "Aruba",
    value: "297",
    code: "AW",
    image: AW,
  },
  {
    label: "Australia",
    value: "61",
    code: "AU",
    image: AU,
  },
  {
    label: "Austria",
    value: "43",
    code: "AT",
    image: AT,
  },
  {
    label: "Azerbaijan",
    value: "994",
    code: "AZ",
    image: AZ,
  },
  {
    label: "Bahamas",
    value: "1242",
    code: "BS",
    image: BS,
  },
  {
    label: "Bahrain",
    value: "973",
    code: "BH",
    image: BH,
  },
  {
    label: "Bangladesh",
    value: "880",
    code: "BD",
    image: BD,
  },
  {
    label: "Barbados",
    value: "1246",
    code: "BB",
    image: BB,
  },
  {
    label: "Belarus",
    value: "375",
    code: "BY",
    image: BY,
  },
  {
    label: "Belgium",
    value: "32",
    code: "BE",
    image: BE,
  },
  {
    label: "Belize",
    value: "501",
    code: "BZ",
    image: BZ,
  },
  {
    label: "Benin",
    value: "229",
    code: "BJ",
    image: BJ,
  },
  {
    label: "Bermuda",
    value: "1441",
    code: "BM",
    image: BM,
  },
  {
    label: "Bhutan",
    value: "975",
    code: "BT",
    image: BT,
  },
  {
    label: "Bolivia",
    value: "591",
    code: "BO",
    image: BO,
  },
  {
    label: "Bosnia and Herzegovina",
    value: "387",
    code: "BA",
    image: BA,
  },
  {
    label: "Botswana",
    value: "267",
    code: "BW",
    image: BW,
  },
  {
    label: "Brazil",
    value: "55",
    code: "BR",
    image: BR,
  },
  {
    label: "British Indian Ocean Territory",
    value: "246",
    code: "IO",
    image: IO,
  },
  {
    label: "Brunei Darussalam",
    value: "673",
    code: "BN",
    image: BN,
  },
  {
    label: "Bulgaria",
    value: "359",
    code: "BG",
    image: BG,
  },
  {
    label: "Burkina Faso",
    value: "226",
    code: "BF",
    image: BF,
  },
  {
    label: "Burundi",
    value: "257",
    code: "BI",
    image: BI,
  },
  {
    label: "Cambodia",
    value: "855",
    code: "KH",
    image: KH,
  },
  {
    label: "Cameroon",
    value: "237",
    code: "CM",
    image: CM,
  },
  {
    label: "Canada",
    value: "1",
    code: "CA",
    image: CA,
  },
  {
    label: "Cape Verde",
    value: "238",
    code: "CV",
    image: CV,
  },
  {
    label: "Cayman Islands",
    value: " 345",
    code: "KY",
    image: KY,
  },
  {
    label: "Central African Republic",
    value: "236",
    code: "CF",
    image: CF,
  },
  {
    label: "Chad",
    value: "235",
    code: "TD",
    image: TD,
  },
  {
    label: "Chile",
    value: "56",
    code: "CL",
    image: CL,
  },
  {
    label: "China",
    value: "86",
    code: "CN",
    image: CN,
  },
  {
    label: "Christmas Island",
    value: "61",
    code: "CX",
    image: CX,
  },
  {
    label: "Cocos (Keeling) Islands",
    value: "61",
    code: "CC",
    image: CC,
  },
  {
    label: "Colombia",
    value: "57",
    code: "CO",
    image: CO,
  },
  {
    label: "Comoros",
    value: "269",
    code: "KM",
    image: KM,
  },
  {
    label: "Congo",
    value: "242",
    code: "CG",
    image: CG,
  },
  {
    label: "Congo, The Democratic Republic of the Congo",
    value: "243",
    code: "CD",
    image: CD,
  },
  {
    label: "Cook Islands",
    value: "682",
    code: "CK",
    image: CK,
  },
  {
    label: "Costa Rica",
    value: "506",
    code: "CR",
    image: CR,
  },
  {
    label: "Cote d'Ivoire",
    value: "225",
    code: "CI",
    image: CI,
  },
  {
    label: "Croatia",
    value: "385",
    code: "HR",
    image: HR,
  },
  {
    label: "Cuba",
    value: "53",
    code: "CU",
    image: CU,
  },
  {
    label: "Cyprus",
    value: "357",
    code: "CY",
    image: CY,
  },
  {
    label: "Czech Republic",
    value: "420",
    code: "CZ",
    image: CZ,
  },
  {
    label: "Denmark",
    value: "45",
    code: "DK",
    image: DK,
  },
  {
    label: "Djibouti",
    value: "253",
    code: "DJ",
    image: DJ,
  },
  {
    label: "Dominica",
    value: "1767",
    code: "DM",
    image: DM,
  },
  {
    label: "Dominican Republic",
    value: "1849",
    code: "DO",
    image: DO,
  },
  {
    label: "Ecuador",
    value: "593",
    code: "EC",
    image: EC,
  },
  {
    label: "Egypt",
    value: "20",
    code: "EG",
    image: EG,
  },
  {
    label: "El Salvador",
    value: "503",
    code: "SV",
    image: SV,
  },
  {
    label: "Equatorial Guinea",
    value: "240",
    code: "GQ",
    image: GQ,
  },
  {
    label: "Eritrea",
    value: "291",
    code: "ER",
    image: ER,
  },
  {
    label: "Estonia",
    value: "372",
    code: "EE",
    image: EE,
  },
  {
    label: "Ethiopia",
    value: "251",
    code: "ET",
    image: ET,
  },
  {
    label: "Falkland Islands (Malvinas)",
    value: "500",
    code: "FK",
    image: FK,
  },
  {
    label: "Faroe Islands",
    value: "298",
    code: "FO",
    image: FO,
  },
  {
    label: "Fiji",
    value: "679",
    code: "FJ",
    image: FJ,
  },
  {
    label: "Finland",
    value: "358",
    code: "FI",
    image: FI,
  },
  {
    label: "France",
    value: "33",
    code: "FR",
    image: FR,
  },
  {
    label: "French Guiana",
    value: "594",
    code: "GF",
    image: GF,
  },
  {
    label: "French Polynesia",
    value: "689",
    code: "PF",
    image: PF,
  },
  {
    label: "Gabon",
    value: "241",
    code: "GA",
    image: GA,
  },
  {
    label: "Gambia",
    value: "220",
    code: "GM",
    image: GM,
  },
  {
    label: "Georgia",
    value: "995",
    code: "GE",
    image: GE,
  },
  {
    label: "Germany",
    value: "49",
    code: "DE",
    image: DE,
  },
  {
    label: "Ghana",
    value: "233",
    code: "GH",
    image: GH,
  },
  {
    label: "Gibraltar",
    value: "350",
    code: "GI",
    image: GI,
  },
  {
    label: "Greece",
    value: "30",
    code: "GR",
    image: GR,
  },
  {
    label: "Greenland",
    value: "299",
    code: "GL",
    image: GL,
  },
  {
    label: "Grenada",
    value: "1473",
    code: "GD",
    image: GD,
  },
  {
    label: "Guadeloupe",
    value: "590",
    code: "GP",
    image: GP,
  },
  {
    label: "Guam",
    value: "1671",
    code: "GU",
    image: GU,
  },
  {
    label: "Guatemala",
    value: "502",
    code: "GT",
    image: GT,
  },
  {
    label: "Guernsey",
    value: "44",
    code: "GG",
    image: GG,
  },
  {
    label: "Guinea",
    value: "224",
    code: "GN",
    image: GN,
  },
  {
    label: "Guinea-Bissau",
    value: "245",
    code: "GW",
    image: GW,
  },
  {
    label: "Guyana",
    value: "595",
    code: "GY",
    image: GY,
  },
  {
    label: "Haiti",
    value: "509",
    code: "HT",
    image: HT,
  },
  {
    label: "Holy See (Vatican City State)",
    value: "379",
    code: "VA",
    image: VA,
  },
  {
    label: "Honduras",
    value: "504",
    code: "HN",
    image: HN,
  },
  {
    label: "Hong Kong",
    value: "852",
    code: "HK",
    image: HK,
  },
  {
    label: "Hungary",
    value: "36",
    code: "HU",
    image: HU,
  },
  {
    label: "Iceland",
    value: "354",
    code: "IS",
    image: IS,
  },
  {
    label: "India",
    value: "91",
    code: "IN",
    image: IN,
  },
  {
    label: "Indonesia",
    value: "62",
    code: "ID",
    image: ID,
  },
  {
    label: "Iran",
    value: "98",
    code: "IR",
    image: IR,
  },
  {
    label: "Iraq",
    value: "964",
    code: "IQ",
    image: IQ,
  },
  {
    label: "Ireland",
    value: "353",
    code: "IE",
    image: IE,
  },
  {
    label: "Isle of Man",
    value: "44",
    code: "IM",
    image: IM,
  },
  {
    label: "Israel",
    value: "972",
    code: "IL",
    image: IL,
  },
  {
    label: "Italy",
    value: "39",
    code: "IT",
    image: IT,
  },
  {
    label: "Jamaica",
    value: "1876",
    code: "JM",
    image: JM,
  },
  {
    label: "Japan",
    value: "81",
    code: "JP",
    image: JP,
  },
  {
    label: "Jersey",
    value: "44",
    code: "JE",
    image: JE,
  },
  {
    label: "Jordan",
    value: "962",
    code: "JO",
    image: JO,
  },
  {
    label: "Kazakhstan",
    value: "77",
    code: "KZ",
    image: KZ,
  },
  {
    label: "Kenya",
    value: "254",
    code: "KE",
    image: KE,
  },
  {
    label: "Kiribati",
    value: "686",
    code: "KI",
    image: KI,
  },
  {
    label: "Korea, Democratic People's Republic of Korea",
    value: "850",
    code: "KP",
    image: KP,
  },
  {
    label: "Korea, Republic of South Korea",
    value: "82",
    code: "KR",
    image: KR,
  },
  {
    label: "Kuwait",
    value: "965",
    code: "KW",
    image: KW,
  },
  {
    label: "Kyrgyzstan",
    value: "996",
    code: "KG",
    image: KG,
  },
  {
    label: "Laos",
    value: "856",
    code: "LA",
    image: LA,
  },
  {
    label: "Latvia",
    value: "371",
    code: "LV",
    image: LV,
  },
  {
    label: "Lebanon",
    value: "961",
    code: "LB",
    image: LB,
  },
  {
    label: "Lesotho",
    value: "266",
    code: "LS",
    image: LS,
  },
  {
    label: "Liberia",
    value: "231",
    code: "LR",
    image: LR,
  },
  {
    label: "Libya",
    value: "218",
    code: "LY",
    image: LY,
  },
  {
    label: "Liechtenstein",
    value: "423",
    code: "LI",
    image: LI,
  },
  {
    label: "Lithuania",
    value: "370",
    code: "LT",
    image: LT,
  },
  {
    label: "Luxembourg",
    value: "352",
    code: "LU",
    image: LU,
  },
  {
    label: "Macao",
    value: "853",
    code: "MO",
    image: MO,
  },
  {
    label: "Macedonia",
    value: "389",
    code: "MK",
    image: MK,
  },
  {
    label: "Madagascar",
    value: "261",
    code: "MG",
    image: MG,
  },
  {
    label: "Malawi",
    value: "265",
    code: "MW",
    image: MW,
  },
  {
    label: "Malaysia",
    value: "60",
    code: "MY",
    image: MY,
  },
  {
    label: "Maldives",
    value: "960",
    code: "MV",
    image: MV,
  },
  {
    label: "Mali",
    value: "223",
    code: "ML",
    image: ML,
  },
  {
    label: "Malta",
    value: "356",
    code: "MT",
    image: MT,
  },
  {
    label: "Marshall Islands",
    value: "692",
    code: "MH",
    image: MH,
  },
  {
    label: "Martinique",
    value: "596",
    code: "MQ",
    image: MQ,
  },
  {
    label: "Mauritania",
    value: "222",
    code: "MR",
    image: MR,
  },
  {
    label: "Mauritius",
    value: "230",
    code: "MU",
    image: MU,
  },
  {
    label: "Mayotte",
    value: "262",
    code: "YT",
    image: YT,
  },
  {
    label: "Mexico",
    value: "52",
    code: "MX",
    image: MX,
  },
  {
    label: "Micronesia, Federated States of Micronesia",
    value: "691",
    code: "FM",
    image: FM,
  },
  {
    label: "Moldova",
    value: "373",
    code: "MD",
    image: MD,
  },
  {
    label: "Monaco",
    value: "377",
    code: "MC",
    image: MC,
  },
  {
    label: "Mongolia",
    value: "976",
    code: "MN",
    image: MN,
  },
  {
    label: "Montenegro",
    value: "382",
    code: "ME",
    image: ME,
  },
  {
    label: "Montserrat",
    value: "1664",
    code: "MS",
    image: MS,
  },
  {
    label: "Morocco",
    value: "212",
    code: "MA",
    image: MA,
  },
  {
    label: "Mozambique",
    value: "258",
    code: "MZ",
    image: MZ,
  },
  {
    label: "Myanmar",
    value: "95",
    code: "MM",
    image: MM,
  },
  {
    label: "Namibia",
    value: "264",
    code: "NA",
    image: NA,
  },
  {
    label: "Nauru",
    value: "674",
    code: "NR",
    image: NR,
  },
  {
    label: "Nepal",
    value: "977",
    code: "NP",
    image: NP,
  },
  {
    label: "Netherlands",
    value: "31",
    code: "NL",
    image: NL,
  },
  // {
  //   label: "Netherlands Antilles",
  //   value: "599",
  //   code: "AN",
  //   image: AN,
  // },
  {
    label: "New Caledonia",
    value: "687",
    code: "NC",
    image: NC,
  },
  {
    label: "New Zealand",
    value: "64",
    code: "NZ",
    image: NZ,
  },
  {
    label: "Nicaragua",
    value: "505",
    code: "NI",
    image: NI,
  },
  {
    label: "Niger",
    value: "227",
    code: "NE",
    image: NE,
  },
  {
    label: "Nigeria",
    value: "234",
    code: "NG",
    image: NG,
  },
  {
    label: "Niue",
    value: "683",
    code: "NU",
    image: NU,
  },
  {
    label: "Norfolk Island",
    value: "672",
    code: "NF",
    image: NF,
  },
  {
    label: "Northern Mariana Islands",
    value: "1670",
    code: "MP",
    image: MP,
  },
  {
    label: "Norway",
    value: "47",
    code: "NO",
    image: NO,
  },
  {
    label: "Oman",
    value: "968",
    code: "OM",
    image: OM,
  },
  {
    label: "Pakistan",
    value: "92",
    code: "PK",
    image: PK,
  },
  {
    label: "Palau",
    value: "680",
    code: "PW",
    image: PW,
  },
  {
    label: "Palestinian Territories",
    value: "970",
    code: "PS",
    image: PS,
  },
  {
    label: "Panama",
    value: "507",
    code: "PA",
    image: PA,
  },
  {
    label: "Papua New Guinea",
    value: "675",
    code: "PG",
    image: PG,
  },
  {
    label: "Paraguay",
    value: "595",
    code: "PY",
    image: PY,
  },
  {
    label: "Peru",
    value: "51",
    code: "PE",
    image: PE,
  },
  {
    label: "Philippines",
    value: "63",
    code: "PH",
    image: PH,
  },
  {
    label: "Pitcairn",
    value: "872",
    code: "PN",
    image: PN,
  },
  {
    label: "Poland",
    value: "48",
    code: "PL",
    image: PL,
  },
  {
    label: "Portugal",
    value: "351",
    code: "PT",
    image: PT,
  },
  {
    label: "Puerto Rico",
    value: "1939",
    code: "PR",
    image: PR,
  },
  {
    label: "Qatar",
    value: "974",
    code: "QA",
    image: QA,
  },
  {
    label: "Romania",
    value: "40",
    code: "RO",
    image: RO,
  },
  {
    label: "Russia",
    value: "7",
    code: "RU",
    image: RU,
  },
  {
    label: "Rwanda",
    value: "250",
    code: "RW",
    image: RW,
  },
  {
    label: "Reunion",
    value: "262",
    code: "RE",
    image: RE,
  },
  {
    label: "Saint Barthelemy",
    value: "590",
    code: "BL",
    image: BL,
  },
  {
    label: "Saint Helena, Ascension and Tristan Da Cunha",
    value: "290",
    code: "SH",
    image: SH,
  },
  {
    label: "Saint Kitts and Nevis",
    value: "1869",
    code: "KN",
    image: KN,
  },
  {
    label: "Saint Lucia",
    value: "1758",
    code: "LC",
    image: LC,
  },
  {
    label: "Saint Martin",
    value: "590",
    code: "MF",
    image: MF,
  },
  {
    label: "Saint Pierre and Miquelon",
    value: "508",
    code: "PM",
    image: PM,
  },
  {
    label: "Saint Vincent and the Grenadines",
    value: "1784",
    code: "VC",
    image: VC,
  },
  {
    label: "Samoa",
    value: "685",
    code: "WS",
    image: WS,
  },
  {
    label: "San Marino",
    value: "378",
    code: "SM",
    image: SM,
  },
  {
    label: "Sao Tome and Principe",
    value: "239",
    code: "ST",
    image: ST,
  },
  {
    label: "Saudi Arabia",
    value: "966",
    code: "SA",
    image: SA,
  },
  {
    label: "Senegal",
    value: "221",
    code: "SN",
    image: SN,
  },
  {
    label: "Serbia",
    value: "381",
    code: "RS",
    image: RS,
  },
  {
    label: "Seychelles",
    value: "248",
    code: "SC",
    image: SC,
  },
  {
    label: "Sierra Leone",
    value: "232",
    code: "SL",
    image: SL,
  },
  {
    label: "Singapore",
    value: "65",
    code: "SG",
    image: SG,
  },
  {
    label: "Slovakia",
    value: "421",
    code: "SK",
    image: SK,
  },
  {
    label: "Slovenia",
    value: "386",
    code: "SI",
    image: SI,
  },
  {
    label: "Solomon Islands",
    value: "677",
    code: "SB",
    image: SB,
  },
  {
    label: "Somalia",
    value: "252",
    code: "SO",
    image: SO,
  },
  {
    label: "South Africa",
    value: "27",
    code: "ZA",
    image: ZA,
  },
  {
    label: "South Sudan",
    value: "211",
    code: "SS",
    image: SS,
  },
  {
    label: "South Georgia and the South Sandwich Islands",
    value: "500",
    code: "GS",
    image: GS,
  },
  {
    label: "Spain",
    value: "34",
    code: "ES",
    image: ES,
  },
  {
    label: "Sri Lanka",
    value: "94",
    code: "LK",
    image: LK,
  },
  {
    label: "Sudan",
    value: "249",
    code: "SD",
    image: SD,
  },
  {
    label: "Suriname",
    value: "597",
    code: "SR",
    image: SR,
  },
  {
    label: "Svalbard and Jan Mayen",
    value: "47",
    code: "SJ",
    image: SJ,
  },
  {
    label: "Swaziland",
    value: "268",
    code: "SZ",
    image: SZ,
  },
  {
    label: "Sweden",
    value: "46",
    code: "SE",
    image: SE,
  },
  {
    label: "Switzerland",
    value: "41",
    code: "CH",
    image: CH,
  },
  {
    label: "Syrian Arab Republic",
    value: "963",
    code: "SY",
    image: SY,
  },
  {
    label: "Taiwan",
    value: "886",
    code: "TW",
    image: TW,
  },
  {
    label: "Tajikistan",
    value: "992",
    code: "TJ",
    image: TJ,
  },
  {
    label: "Tanzania, United Republic of Tanzania",
    value: "255",
    code: "TZ",
    image: TZ,
  },
  {
    label: "Thailand",
    value: "66",
    code: "TH",
    image: TH,
  },
  {
    label: "Timor-Leste",
    value: "670",
    code: "TL",
    image: TL,
  },
  {
    label: "Togo",
    value: "228",
    code: "TG",
    image: TG,
  },
  {
    label: "Tokelau",
    value: "690",
    code: "TK",
    image: TK,
  },
  {
    label: "Tonga",
    value: "676",
    code: "TO",
    image: TO,
  },
  {
    label: "Trinidad and Tobago",
    value: "1868",
    code: "TT",
    image: TT,
  },
  {
    label: "Tunisia",
    value: "216",
    code: "TN",
    image: TN,
  },
  {
    label: "Turkey",
    value: "90",
    code: "TR",
    image: TR,
  },
  {
    label: "Turkmenistan",
    value: "993",
    code: "TM",
    image: TM,
  },
  {
    label: "Turks and Caicos Islands",
    value: "1649",
    code: "TC",
    image: TC,
  },
  {
    label: "Tuvalu",
    value: "688",
    code: "TV",
    image: TV,
  },
  {
    label: "Uganda",
    value: "256",
    code: "UG",
    image: UG,
  },
  {
    label: "Ukraine",
    value: "380",
    code: "UA",
    image: UA,
  },
  {
    label: "United Arab Emirates",
    value: "971",
    code: "AE",
    image: AE,
  },
  {
    label: "United Kingdom",
    value: "44",
    code: "GB",
    image: GB,
  },
  {
    label: "United States",
    value: "1",
    code: "US",
    image: US,
  },
  {
    label: "Uruguay",
    value: "598",
    code: "UY",
    image: UY,
  },
  {
    label: "Uzbekistan",
    value: "998",
    code: "UZ",
    image: UZ,
  },
  {
    label: "Vanuatu",
    value: "678",
    code: "VU",
    image: VU,
  },
  {
    label: "Venezuela, Bolivarian Republic of Venezuela",
    value: "58",
    code: "VE",
    image: VE,
  },
  {
    label: "Vietnam",
    value: "84",
    code: "VN",
    image: VN,
  },
  {
    label: "Virgin Islands, British",
    value: "1284",
    code: "VG",
    image: VG,
  },
  {
    label: "Virgin Islands, U.S.",
    value: "1340",
    code: "VI",
    image: VI,
  },
  {
    label: "Wallis and Futuna",
    value: "681",
    code: "WF",
    image: WF,
  },
  {
    label: "Yemen",
    value: "967",
    code: "YE",
    image: YE,
  },
  {
    label: "Zambia",
    value: "260",
    code: "ZM",
    image: ZM,
  },
  {
    label: "Zimbabwe",
    value: "263",
    code: "ZW",
    image: ZW,
  },
];

export default FieldPhoneCountry;
